/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as EmbedRouteRouteImport } from './routes/embed/route'
import { Route as DashboardRouteRouteImport } from './routes/_dashboard/route'
import { Route as EmbedIndexRouteImport } from './routes/embed/index'
import { Route as publicIndexRouteImport } from './routes/(public)/index'
import { Route as EmbedSignupCompleteRouteImport } from './routes/embed/signup-complete'
import { Route as DashboardResumeRouteImport } from './routes/_dashboard/resume'
import { Route as DashboardDocumentsRouteImport } from './routes/_dashboard/documents'
import { Route as publicFundreadyRouteImport } from './routes/(public)/fundready'
import { Route as DashboardPartnersRouteRouteImport } from './routes/_dashboard/partners/route'
import { Route as DashboardLenderRouteRouteImport } from './routes/_dashboard/lender/route'
import { Route as DashboardFundingRequestsRouteRouteImport } from './routes/_dashboard/funding-requests/route'
import { Route as DashboardCompanyRouteRouteImport } from './routes/_dashboard/company/route'
import { Route as DashboardApplicationsRouteRouteImport } from './routes/_dashboard/applications/route'
import { Route as DashboardCustomerRouteRouteImport } from './routes/_dashboard/_customer/route'
import { Route as DashboardApplicationFlowRouteRouteImport } from './routes/_dashboard/_application-flow/route'
import { Route as publicAccountRouteRouteImport } from './routes/(public)/_account/route'
import { Route as DashboardPartnersIndexRouteImport } from './routes/_dashboard/partners/index'
import { Route as DashboardLenderIndexRouteImport } from './routes/_dashboard/lender/index'
import { Route as DashboardFundingRequestsIndexRouteImport } from './routes/_dashboard/funding-requests/index'
import { Route as DashboardCompanyIndexRouteImport } from './routes/_dashboard/company/index'
import { Route as DashboardApplicationsIndexRouteImport } from './routes/_dashboard/applications/index'
import { Route as DashboardSettingsMyAccountRouteImport } from './routes/_dashboard/settings/my-account'
import { Route as DashboardPartnersUsersRouteImport } from './routes/_dashboard/partners/users'
import { Route as DashboardPartnersReferralsRouteImport } from './routes/_dashboard/partners/referrals'
import { Route as DashboardPartnersHomeRouteImport } from './routes/_dashboard/partners/home'
import { Route as DashboardPartnersGuideRouteImport } from './routes/_dashboard/partners/guide'
import { Route as DashboardPartnersBankingRouteImport } from './routes/_dashboard/partners/banking'
import { Route as DashboardLenderUsersRouteImport } from './routes/_dashboard/lender/users'
import { Route as DashboardLenderProfileRouteImport } from './routes/_dashboard/lender/profile'
import { Route as DashboardLenderHomeRouteImport } from './routes/_dashboard/lender/home'
import { Route as DashboardCompanyPlaidRouteImport } from './routes/_dashboard/company/plaid'
import { Route as DashboardCompanyOwnershipDetailsRouteImport } from './routes/_dashboard/company/ownership-details'
import { Route as DashboardCompanyExtraDetailsRouteImport } from './routes/_dashboard/company/extra-details'
import { Route as DashboardCompanyDetailsRouteImport } from './routes/_dashboard/company/details'
import { Route as DashboardCompanyDebtTableRouteImport } from './routes/_dashboard/company/debt-table'
import { Route as DashboardCompanyArticlesOfIncorporationRouteImport } from './routes/_dashboard/company/articles-of-incorporation'
import { Route as DashboardCompanyAddressRouteImport } from './routes/_dashboard/company/address'
import { Route as DashboardCustomerReferRouteImport } from './routes/_dashboard/_customer/refer'
import { Route as DashboardCustomerPerksRouteImport } from './routes/_dashboard/_customer/perks'
import { Route as DashboardCustomerHomeRouteImport } from './routes/_dashboard/_customer/home'
import { Route as DashboardCustomerDebtTableRouteImport } from './routes/_dashboard/_customer/debt-table'
import { Route as DashboardCustomerCompaniesRouteImport } from './routes/_dashboard/_customer/companies'
import { Route as publicAccountSignupRouteImport } from './routes/(public)/_account/signup'
import { Route as publicAccountResetPasswordRouteImport } from './routes/(public)/_account/reset-password'
import { Route as publicAccountLoginRouteImport } from './routes/(public)/_account/login'
import { Route as publicAccountInvitationRouteImport } from './routes/(public)/_account/invitation'
import { Route as publicAccountForgotPasswordRouteImport } from './routes/(public)/_account/forgot-password'
import { Route as publicAccountCompanyInvitationRouteImport } from './routes/(public)/_account/company-invitation'
import { Route as DashboardCustomerUsersRouteRouteImport } from './routes/_dashboard/_customer/users/route'
import { Route as publicPSlugRouteRouteImport } from './routes/(public)/p/$slug/route'
import { Route as DashboardPartnersCompaniesIndexRouteImport } from './routes/_dashboard/partners/companies/index'
import { Route as DashboardLenderApplicationsIndexRouteImport } from './routes/_dashboard/lender/applications/index'
import { Route as DashboardCustomerUsersIndexRouteImport } from './routes/_dashboard/_customer/users/index'
import { Route as publicPSlugIndexRouteImport } from './routes/(public)/p/$slug/index'
import { Route as DashboardPartnersCompaniesManageRouteImport } from './routes/_dashboard/partners/companies/manage'
import { Route as DashboardPartnersCompaniesAddRouteImport } from './routes/_dashboard/partners/companies/add'
import { Route as DashboardLenderApplicationsListRouteImport } from './routes/_dashboard/lender/applications/list'
import { Route as DashboardApplicationsApplicationUuidSummaryRouteImport } from './routes/_dashboard/applications/$applicationUuid.summary'
import { Route as DashboardCustomerUsersActivityRouteImport } from './routes/_dashboard/_customer/users/activity'
import { Route as DashboardApplicationFlowFundingRequestsCreateRouteImport } from './routes/_dashboard/_application-flow/funding-requests/create'
import { Route as publicPSlugSignupRouteImport } from './routes/(public)/p/$slug/signup'
import { Route as publicPSlugLoginRouteImport } from './routes/(public)/p/$slug/login'
import { Route as DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRouteImport } from './routes/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid/route'
import { Route as DashboardApplicationFlowApplicationsApplicationUuidRouteRouteImport } from './routes/_dashboard/_application-flow/applications/$applicationUuid/route'
import { Route as DashboardApplicationFlowFundingRequestsFundingNeedsUuidIndexRouteImport } from './routes/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid/index'
import { Route as DashboardLenderApplicationsDetailsUuidRouteImport } from './routes/_dashboard/lender/applications/details.$uuid'
import { Route as DashboardApplicationFlowFundingRequestsFundingNeedsUuidLenderMatchRouteImport } from './routes/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid/lender-match'
import { Route as DashboardApplicationFlowApplicationsApplicationUuidUploadDocumentsRouteImport } from './routes/_dashboard/_application-flow/applications/$applicationUuid/upload-documents'
import { Route as DashboardApplicationFlowApplicationsApplicationUuidSubmitRouteImport } from './routes/_dashboard/_application-flow/applications/$applicationUuid/submit'
import { Route as DashboardApplicationFlowApplicationsApplicationUuidSignRouteImport } from './routes/_dashboard/_application-flow/applications/$applicationUuid/sign'

const EmbedRouteRoute = EmbedRouteRouteImport.update({
  id: '/embed',
  path: '/embed',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/_dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedIndexRoute = EmbedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => EmbedRouteRoute,
} as any)
const publicIndexRoute = publicIndexRouteImport.update({
  id: '/(public)/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmbedSignupCompleteRoute = EmbedSignupCompleteRouteImport.update({
  id: '/signup-complete',
  path: '/signup-complete',
  getParentRoute: () => EmbedRouteRoute,
} as any)
const DashboardResumeRoute = DashboardResumeRouteImport.update({
  id: '/resume',
  path: '/resume',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardDocumentsRoute = DashboardDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const publicFundreadyRoute = publicFundreadyRouteImport.update({
  id: '/(public)/fundready',
  path: '/fundready',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardPartnersRouteRoute = DashboardPartnersRouteRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardLenderRouteRoute = DashboardLenderRouteRouteImport.update({
  id: '/lender',
  path: '/lender',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardFundingRequestsRouteRoute =
  DashboardFundingRequestsRouteRouteImport.update({
    id: '/funding-requests',
    path: '/funding-requests',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCompanyRouteRoute = DashboardCompanyRouteRouteImport.update({
  id: '/company',
  path: '/company',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardApplicationsRouteRoute =
  DashboardApplicationsRouteRouteImport.update({
    id: '/applications',
    path: '/applications',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardCustomerRouteRoute = DashboardCustomerRouteRouteImport.update({
  id: '/_customer',
  getParentRoute: () => DashboardRouteRoute,
} as any)
const DashboardApplicationFlowRouteRoute =
  DashboardApplicationFlowRouteRouteImport.update({
    id: '/_application-flow',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const publicAccountRouteRoute = publicAccountRouteRouteImport.update({
  id: '/(public)/_account',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardPartnersIndexRoute = DashboardPartnersIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardPartnersRouteRoute,
} as any)
const DashboardLenderIndexRoute = DashboardLenderIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardLenderRouteRoute,
} as any)
const DashboardFundingRequestsIndexRoute =
  DashboardFundingRequestsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardFundingRequestsRouteRoute,
  } as any)
const DashboardCompanyIndexRoute = DashboardCompanyIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DashboardCompanyRouteRoute,
} as any)
const DashboardApplicationsIndexRoute =
  DashboardApplicationsIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardApplicationsRouteRoute,
  } as any)
const DashboardSettingsMyAccountRoute =
  DashboardSettingsMyAccountRouteImport.update({
    id: '/settings/my-account',
    path: '/settings/my-account',
    getParentRoute: () => DashboardRouteRoute,
  } as any)
const DashboardPartnersUsersRoute = DashboardPartnersUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => DashboardPartnersRouteRoute,
} as any)
const DashboardPartnersReferralsRoute =
  DashboardPartnersReferralsRouteImport.update({
    id: '/referrals',
    path: '/referrals',
    getParentRoute: () => DashboardPartnersRouteRoute,
  } as any)
const DashboardPartnersHomeRoute = DashboardPartnersHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => DashboardPartnersRouteRoute,
} as any)
const DashboardPartnersGuideRoute = DashboardPartnersGuideRouteImport.update({
  id: '/guide',
  path: '/guide',
  getParentRoute: () => DashboardPartnersRouteRoute,
} as any)
const DashboardPartnersBankingRoute =
  DashboardPartnersBankingRouteImport.update({
    id: '/banking',
    path: '/banking',
    getParentRoute: () => DashboardPartnersRouteRoute,
  } as any)
const DashboardLenderUsersRoute = DashboardLenderUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => DashboardLenderRouteRoute,
} as any)
const DashboardLenderProfileRoute = DashboardLenderProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DashboardLenderRouteRoute,
} as any)
const DashboardLenderHomeRoute = DashboardLenderHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => DashboardLenderRouteRoute,
} as any)
const DashboardCompanyPlaidRoute = DashboardCompanyPlaidRouteImport.update({
  id: '/plaid',
  path: '/plaid',
  getParentRoute: () => DashboardCompanyRouteRoute,
} as any)
const DashboardCompanyOwnershipDetailsRoute =
  DashboardCompanyOwnershipDetailsRouteImport.update({
    id: '/ownership-details',
    path: '/ownership-details',
    getParentRoute: () => DashboardCompanyRouteRoute,
  } as any)
const DashboardCompanyExtraDetailsRoute =
  DashboardCompanyExtraDetailsRouteImport.update({
    id: '/extra-details',
    path: '/extra-details',
    getParentRoute: () => DashboardCompanyRouteRoute,
  } as any)
const DashboardCompanyDetailsRoute = DashboardCompanyDetailsRouteImport.update({
  id: '/details',
  path: '/details',
  getParentRoute: () => DashboardCompanyRouteRoute,
} as any)
const DashboardCompanyDebtTableRoute =
  DashboardCompanyDebtTableRouteImport.update({
    id: '/debt-table',
    path: '/debt-table',
    getParentRoute: () => DashboardCompanyRouteRoute,
  } as any)
const DashboardCompanyArticlesOfIncorporationRoute =
  DashboardCompanyArticlesOfIncorporationRouteImport.update({
    id: '/articles-of-incorporation',
    path: '/articles-of-incorporation',
    getParentRoute: () => DashboardCompanyRouteRoute,
  } as any)
const DashboardCompanyAddressRoute = DashboardCompanyAddressRouteImport.update({
  id: '/address',
  path: '/address',
  getParentRoute: () => DashboardCompanyRouteRoute,
} as any)
const DashboardCustomerReferRoute = DashboardCustomerReferRouteImport.update({
  id: '/refer',
  path: '/refer',
  getParentRoute: () => DashboardCustomerRouteRoute,
} as any)
const DashboardCustomerPerksRoute = DashboardCustomerPerksRouteImport.update({
  id: '/perks',
  path: '/perks',
  getParentRoute: () => DashboardCustomerRouteRoute,
} as any)
const DashboardCustomerHomeRoute = DashboardCustomerHomeRouteImport.update({
  id: '/home',
  path: '/home',
  getParentRoute: () => DashboardCustomerRouteRoute,
} as any)
const DashboardCustomerDebtTableRoute =
  DashboardCustomerDebtTableRouteImport.update({
    id: '/debt-table',
    path: '/debt-table',
    getParentRoute: () => DashboardCustomerRouteRoute,
  } as any)
const DashboardCustomerCompaniesRoute =
  DashboardCustomerCompaniesRouteImport.update({
    id: '/companies',
    path: '/companies',
    getParentRoute: () => DashboardCustomerRouteRoute,
  } as any)
const publicAccountSignupRoute = publicAccountSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => publicAccountRouteRoute,
} as any)
const publicAccountResetPasswordRoute =
  publicAccountResetPasswordRouteImport.update({
    id: '/reset-password',
    path: '/reset-password',
    getParentRoute: () => publicAccountRouteRoute,
  } as any)
const publicAccountLoginRoute = publicAccountLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => publicAccountRouteRoute,
} as any)
const publicAccountInvitationRoute = publicAccountInvitationRouteImport.update({
  id: '/invitation',
  path: '/invitation',
  getParentRoute: () => publicAccountRouteRoute,
} as any)
const publicAccountForgotPasswordRoute =
  publicAccountForgotPasswordRouteImport.update({
    id: '/forgot-password',
    path: '/forgot-password',
    getParentRoute: () => publicAccountRouteRoute,
  } as any)
const publicAccountCompanyInvitationRoute =
  publicAccountCompanyInvitationRouteImport.update({
    id: '/company-invitation',
    path: '/company-invitation',
    getParentRoute: () => publicAccountRouteRoute,
  } as any)
const DashboardCustomerUsersRouteRoute =
  DashboardCustomerUsersRouteRouteImport.update({
    id: '/users',
    path: '/users',
    getParentRoute: () => DashboardCustomerRouteRoute,
  } as any)
const publicPSlugRouteRoute = publicPSlugRouteRouteImport.update({
  id: '/(public)/p/$slug',
  path: '/p/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardPartnersCompaniesIndexRoute =
  DashboardPartnersCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => DashboardPartnersRouteRoute,
  } as any)
const DashboardLenderApplicationsIndexRoute =
  DashboardLenderApplicationsIndexRouteImport.update({
    id: '/applications/',
    path: '/applications/',
    getParentRoute: () => DashboardLenderRouteRoute,
  } as any)
const DashboardCustomerUsersIndexRoute =
  DashboardCustomerUsersIndexRouteImport.update({
    id: '/',
    path: '/',
    getParentRoute: () => DashboardCustomerUsersRouteRoute,
  } as any)
const publicPSlugIndexRoute = publicPSlugIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => publicPSlugRouteRoute,
} as any)
const DashboardPartnersCompaniesManageRoute =
  DashboardPartnersCompaniesManageRouteImport.update({
    id: '/companies/manage',
    path: '/companies/manage',
    getParentRoute: () => DashboardPartnersRouteRoute,
  } as any)
const DashboardPartnersCompaniesAddRoute =
  DashboardPartnersCompaniesAddRouteImport.update({
    id: '/companies/add',
    path: '/companies/add',
    getParentRoute: () => DashboardPartnersRouteRoute,
  } as any)
const DashboardLenderApplicationsListRoute =
  DashboardLenderApplicationsListRouteImport.update({
    id: '/applications/list',
    path: '/applications/list',
    getParentRoute: () => DashboardLenderRouteRoute,
  } as any)
const DashboardApplicationsApplicationUuidSummaryRoute =
  DashboardApplicationsApplicationUuidSummaryRouteImport.update({
    id: '/$applicationUuid/summary',
    path: '/$applicationUuid/summary',
    getParentRoute: () => DashboardApplicationsRouteRoute,
  } as any)
const DashboardCustomerUsersActivityRoute =
  DashboardCustomerUsersActivityRouteImport.update({
    id: '/activity',
    path: '/activity',
    getParentRoute: () => DashboardCustomerUsersRouteRoute,
  } as any)
const DashboardApplicationFlowFundingRequestsCreateRoute =
  DashboardApplicationFlowFundingRequestsCreateRouteImport.update({
    id: '/funding-requests/create',
    path: '/funding-requests/create',
    getParentRoute: () => DashboardApplicationFlowRouteRoute,
  } as any)
const publicPSlugSignupRoute = publicPSlugSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => publicPSlugRouteRoute,
} as any)
const publicPSlugLoginRoute = publicPSlugLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => publicPSlugRouteRoute,
} as any)
const DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRoute =
  DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRouteImport.update(
    {
      id: '/funding-requests/$fundingNeedsUuid',
      path: '/funding-requests/$fundingNeedsUuid',
      getParentRoute: () => DashboardApplicationFlowRouteRoute,
    } as any,
  )
const DashboardApplicationFlowApplicationsApplicationUuidRouteRoute =
  DashboardApplicationFlowApplicationsApplicationUuidRouteRouteImport.update({
    id: '/applications/$applicationUuid',
    path: '/applications/$applicationUuid',
    getParentRoute: () => DashboardApplicationFlowRouteRoute,
  } as any)
const DashboardApplicationFlowFundingRequestsFundingNeedsUuidIndexRoute =
  DashboardApplicationFlowFundingRequestsFundingNeedsUuidIndexRouteImport.update(
    {
      id: '/',
      path: '/',
      getParentRoute: () =>
        DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRoute,
    } as any,
  )
const DashboardLenderApplicationsDetailsUuidRoute =
  DashboardLenderApplicationsDetailsUuidRouteImport.update({
    id: '/applications/details/$uuid',
    path: '/applications/details/$uuid',
    getParentRoute: () => DashboardLenderRouteRoute,
  } as any)
const DashboardApplicationFlowFundingRequestsFundingNeedsUuidLenderMatchRoute =
  DashboardApplicationFlowFundingRequestsFundingNeedsUuidLenderMatchRouteImport.update(
    {
      id: '/lender-match',
      path: '/lender-match',
      getParentRoute: () =>
        DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRoute,
    } as any,
  )
const DashboardApplicationFlowApplicationsApplicationUuidUploadDocumentsRoute =
  DashboardApplicationFlowApplicationsApplicationUuidUploadDocumentsRouteImport.update(
    {
      id: '/upload-documents',
      path: '/upload-documents',
      getParentRoute: () =>
        DashboardApplicationFlowApplicationsApplicationUuidRouteRoute,
    } as any,
  )
const DashboardApplicationFlowApplicationsApplicationUuidSubmitRoute =
  DashboardApplicationFlowApplicationsApplicationUuidSubmitRouteImport.update({
    id: '/submit',
    path: '/submit',
    getParentRoute: () =>
      DashboardApplicationFlowApplicationsApplicationUuidRouteRoute,
  } as any)
const DashboardApplicationFlowApplicationsApplicationUuidSignRoute =
  DashboardApplicationFlowApplicationsApplicationUuidSignRouteImport.update({
    id: '/sign',
    path: '/sign',
    getParentRoute: () =>
      DashboardApplicationFlowApplicationsApplicationUuidRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof publicIndexRoute
  '/embed': typeof EmbedRouteRouteWithChildren
  '/applications': typeof DashboardApplicationsRouteRouteWithChildren
  '/company': typeof DashboardCompanyRouteRouteWithChildren
  '/funding-requests': typeof DashboardFundingRequestsRouteRouteWithChildren
  '/lender': typeof DashboardLenderRouteRouteWithChildren
  '/partners': typeof DashboardPartnersRouteRouteWithChildren
  '/fundready': typeof publicFundreadyRoute
  '/documents': typeof DashboardDocumentsRoute
  '/resume': typeof DashboardResumeRoute
  '/embed/signup-complete': typeof EmbedSignupCompleteRoute
  '/embed/': typeof EmbedIndexRoute
  '/p/$slug': typeof publicPSlugRouteRouteWithChildren
  '/users': typeof DashboardCustomerUsersRouteRouteWithChildren
  '/company-invitation': typeof publicAccountCompanyInvitationRoute
  '/forgot-password': typeof publicAccountForgotPasswordRoute
  '/invitation': typeof publicAccountInvitationRoute
  '/login': typeof publicAccountLoginRoute
  '/reset-password': typeof publicAccountResetPasswordRoute
  '/signup': typeof publicAccountSignupRoute
  '/companies': typeof DashboardCustomerCompaniesRoute
  '/debt-table': typeof DashboardCustomerDebtTableRoute
  '/home': typeof DashboardCustomerHomeRoute
  '/perks': typeof DashboardCustomerPerksRoute
  '/refer': typeof DashboardCustomerReferRoute
  '/company/address': typeof DashboardCompanyAddressRoute
  '/company/articles-of-incorporation': typeof DashboardCompanyArticlesOfIncorporationRoute
  '/company/debt-table': typeof DashboardCompanyDebtTableRoute
  '/company/details': typeof DashboardCompanyDetailsRoute
  '/company/extra-details': typeof DashboardCompanyExtraDetailsRoute
  '/company/ownership-details': typeof DashboardCompanyOwnershipDetailsRoute
  '/company/plaid': typeof DashboardCompanyPlaidRoute
  '/lender/home': typeof DashboardLenderHomeRoute
  '/lender/profile': typeof DashboardLenderProfileRoute
  '/lender/users': typeof DashboardLenderUsersRoute
  '/partners/banking': typeof DashboardPartnersBankingRoute
  '/partners/guide': typeof DashboardPartnersGuideRoute
  '/partners/home': typeof DashboardPartnersHomeRoute
  '/partners/referrals': typeof DashboardPartnersReferralsRoute
  '/partners/users': typeof DashboardPartnersUsersRoute
  '/settings/my-account': typeof DashboardSettingsMyAccountRoute
  '/applications/': typeof DashboardApplicationsIndexRoute
  '/company/': typeof DashboardCompanyIndexRoute
  '/funding-requests/': typeof DashboardFundingRequestsIndexRoute
  '/lender/': typeof DashboardLenderIndexRoute
  '/partners/': typeof DashboardPartnersIndexRoute
  '/applications/$applicationUuid': typeof DashboardApplicationFlowApplicationsApplicationUuidRouteRouteWithChildren
  '/funding-requests/$fundingNeedsUuid': typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRouteWithChildren
  '/p/$slug/login': typeof publicPSlugLoginRoute
  '/p/$slug/signup': typeof publicPSlugSignupRoute
  '/funding-requests/create': typeof DashboardApplicationFlowFundingRequestsCreateRoute
  '/users/activity': typeof DashboardCustomerUsersActivityRoute
  '/applications/$applicationUuid/summary': typeof DashboardApplicationsApplicationUuidSummaryRoute
  '/lender/applications/list': typeof DashboardLenderApplicationsListRoute
  '/partners/companies/add': typeof DashboardPartnersCompaniesAddRoute
  '/partners/companies/manage': typeof DashboardPartnersCompaniesManageRoute
  '/p/$slug/': typeof publicPSlugIndexRoute
  '/users/': typeof DashboardCustomerUsersIndexRoute
  '/lender/applications/': typeof DashboardLenderApplicationsIndexRoute
  '/partners/companies/': typeof DashboardPartnersCompaniesIndexRoute
  '/applications/$applicationUuid/sign': typeof DashboardApplicationFlowApplicationsApplicationUuidSignRoute
  '/applications/$applicationUuid/submit': typeof DashboardApplicationFlowApplicationsApplicationUuidSubmitRoute
  '/applications/$applicationUuid/upload-documents': typeof DashboardApplicationFlowApplicationsApplicationUuidUploadDocumentsRoute
  '/funding-requests/$fundingNeedsUuid/lender-match': typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidLenderMatchRoute
  '/lender/applications/details/$uuid': typeof DashboardLenderApplicationsDetailsUuidRoute
  '/funding-requests/$fundingNeedsUuid/': typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof publicIndexRoute
  '/fundready': typeof publicFundreadyRoute
  '/documents': typeof DashboardDocumentsRoute
  '/resume': typeof DashboardResumeRoute
  '/embed/signup-complete': typeof EmbedSignupCompleteRoute
  '/embed': typeof EmbedIndexRoute
  '/company-invitation': typeof publicAccountCompanyInvitationRoute
  '/forgot-password': typeof publicAccountForgotPasswordRoute
  '/invitation': typeof publicAccountInvitationRoute
  '/login': typeof publicAccountLoginRoute
  '/reset-password': typeof publicAccountResetPasswordRoute
  '/signup': typeof publicAccountSignupRoute
  '/companies': typeof DashboardCustomerCompaniesRoute
  '/debt-table': typeof DashboardCustomerDebtTableRoute
  '/home': typeof DashboardCustomerHomeRoute
  '/perks': typeof DashboardCustomerPerksRoute
  '/refer': typeof DashboardCustomerReferRoute
  '/company/address': typeof DashboardCompanyAddressRoute
  '/company/articles-of-incorporation': typeof DashboardCompanyArticlesOfIncorporationRoute
  '/company/debt-table': typeof DashboardCompanyDebtTableRoute
  '/company/details': typeof DashboardCompanyDetailsRoute
  '/company/extra-details': typeof DashboardCompanyExtraDetailsRoute
  '/company/ownership-details': typeof DashboardCompanyOwnershipDetailsRoute
  '/company/plaid': typeof DashboardCompanyPlaidRoute
  '/lender/home': typeof DashboardLenderHomeRoute
  '/lender/profile': typeof DashboardLenderProfileRoute
  '/lender/users': typeof DashboardLenderUsersRoute
  '/partners/banking': typeof DashboardPartnersBankingRoute
  '/partners/guide': typeof DashboardPartnersGuideRoute
  '/partners/home': typeof DashboardPartnersHomeRoute
  '/partners/referrals': typeof DashboardPartnersReferralsRoute
  '/partners/users': typeof DashboardPartnersUsersRoute
  '/settings/my-account': typeof DashboardSettingsMyAccountRoute
  '/applications': typeof DashboardApplicationsIndexRoute
  '/company': typeof DashboardCompanyIndexRoute
  '/funding-requests': typeof DashboardFundingRequestsIndexRoute
  '/lender': typeof DashboardLenderIndexRoute
  '/partners': typeof DashboardPartnersIndexRoute
  '/applications/$applicationUuid': typeof DashboardApplicationFlowApplicationsApplicationUuidRouteRouteWithChildren
  '/p/$slug/login': typeof publicPSlugLoginRoute
  '/p/$slug/signup': typeof publicPSlugSignupRoute
  '/funding-requests/create': typeof DashboardApplicationFlowFundingRequestsCreateRoute
  '/users/activity': typeof DashboardCustomerUsersActivityRoute
  '/applications/$applicationUuid/summary': typeof DashboardApplicationsApplicationUuidSummaryRoute
  '/lender/applications/list': typeof DashboardLenderApplicationsListRoute
  '/partners/companies/add': typeof DashboardPartnersCompaniesAddRoute
  '/partners/companies/manage': typeof DashboardPartnersCompaniesManageRoute
  '/p/$slug': typeof publicPSlugIndexRoute
  '/users': typeof DashboardCustomerUsersIndexRoute
  '/lender/applications': typeof DashboardLenderApplicationsIndexRoute
  '/partners/companies': typeof DashboardPartnersCompaniesIndexRoute
  '/applications/$applicationUuid/sign': typeof DashboardApplicationFlowApplicationsApplicationUuidSignRoute
  '/applications/$applicationUuid/submit': typeof DashboardApplicationFlowApplicationsApplicationUuidSubmitRoute
  '/applications/$applicationUuid/upload-documents': typeof DashboardApplicationFlowApplicationsApplicationUuidUploadDocumentsRoute
  '/funding-requests/$fundingNeedsUuid/lender-match': typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidLenderMatchRoute
  '/lender/applications/details/$uuid': typeof DashboardLenderApplicationsDetailsUuidRoute
  '/funding-requests/$fundingNeedsUuid': typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_dashboard': typeof DashboardRouteRouteWithChildren
  '/embed': typeof EmbedRouteRouteWithChildren
  '/(public)/_account': typeof publicAccountRouteRouteWithChildren
  '/_dashboard/_application-flow': typeof DashboardApplicationFlowRouteRouteWithChildren
  '/_dashboard/_customer': typeof DashboardCustomerRouteRouteWithChildren
  '/_dashboard/applications': typeof DashboardApplicationsRouteRouteWithChildren
  '/_dashboard/company': typeof DashboardCompanyRouteRouteWithChildren
  '/_dashboard/funding-requests': typeof DashboardFundingRequestsRouteRouteWithChildren
  '/_dashboard/lender': typeof DashboardLenderRouteRouteWithChildren
  '/_dashboard/partners': typeof DashboardPartnersRouteRouteWithChildren
  '/(public)/fundready': typeof publicFundreadyRoute
  '/_dashboard/documents': typeof DashboardDocumentsRoute
  '/_dashboard/resume': typeof DashboardResumeRoute
  '/embed/signup-complete': typeof EmbedSignupCompleteRoute
  '/(public)/': typeof publicIndexRoute
  '/embed/': typeof EmbedIndexRoute
  '/(public)/p/$slug': typeof publicPSlugRouteRouteWithChildren
  '/_dashboard/_customer/users': typeof DashboardCustomerUsersRouteRouteWithChildren
  '/(public)/_account/company-invitation': typeof publicAccountCompanyInvitationRoute
  '/(public)/_account/forgot-password': typeof publicAccountForgotPasswordRoute
  '/(public)/_account/invitation': typeof publicAccountInvitationRoute
  '/(public)/_account/login': typeof publicAccountLoginRoute
  '/(public)/_account/reset-password': typeof publicAccountResetPasswordRoute
  '/(public)/_account/signup': typeof publicAccountSignupRoute
  '/_dashboard/_customer/companies': typeof DashboardCustomerCompaniesRoute
  '/_dashboard/_customer/debt-table': typeof DashboardCustomerDebtTableRoute
  '/_dashboard/_customer/home': typeof DashboardCustomerHomeRoute
  '/_dashboard/_customer/perks': typeof DashboardCustomerPerksRoute
  '/_dashboard/_customer/refer': typeof DashboardCustomerReferRoute
  '/_dashboard/company/address': typeof DashboardCompanyAddressRoute
  '/_dashboard/company/articles-of-incorporation': typeof DashboardCompanyArticlesOfIncorporationRoute
  '/_dashboard/company/debt-table': typeof DashboardCompanyDebtTableRoute
  '/_dashboard/company/details': typeof DashboardCompanyDetailsRoute
  '/_dashboard/company/extra-details': typeof DashboardCompanyExtraDetailsRoute
  '/_dashboard/company/ownership-details': typeof DashboardCompanyOwnershipDetailsRoute
  '/_dashboard/company/plaid': typeof DashboardCompanyPlaidRoute
  '/_dashboard/lender/home': typeof DashboardLenderHomeRoute
  '/_dashboard/lender/profile': typeof DashboardLenderProfileRoute
  '/_dashboard/lender/users': typeof DashboardLenderUsersRoute
  '/_dashboard/partners/banking': typeof DashboardPartnersBankingRoute
  '/_dashboard/partners/guide': typeof DashboardPartnersGuideRoute
  '/_dashboard/partners/home': typeof DashboardPartnersHomeRoute
  '/_dashboard/partners/referrals': typeof DashboardPartnersReferralsRoute
  '/_dashboard/partners/users': typeof DashboardPartnersUsersRoute
  '/_dashboard/settings/my-account': typeof DashboardSettingsMyAccountRoute
  '/_dashboard/applications/': typeof DashboardApplicationsIndexRoute
  '/_dashboard/company/': typeof DashboardCompanyIndexRoute
  '/_dashboard/funding-requests/': typeof DashboardFundingRequestsIndexRoute
  '/_dashboard/lender/': typeof DashboardLenderIndexRoute
  '/_dashboard/partners/': typeof DashboardPartnersIndexRoute
  '/_dashboard/_application-flow/applications/$applicationUuid': typeof DashboardApplicationFlowApplicationsApplicationUuidRouteRouteWithChildren
  '/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid': typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRouteWithChildren
  '/(public)/p/$slug/login': typeof publicPSlugLoginRoute
  '/(public)/p/$slug/signup': typeof publicPSlugSignupRoute
  '/_dashboard/_application-flow/funding-requests/create': typeof DashboardApplicationFlowFundingRequestsCreateRoute
  '/_dashboard/_customer/users/activity': typeof DashboardCustomerUsersActivityRoute
  '/_dashboard/applications/$applicationUuid/summary': typeof DashboardApplicationsApplicationUuidSummaryRoute
  '/_dashboard/lender/applications/list': typeof DashboardLenderApplicationsListRoute
  '/_dashboard/partners/companies/add': typeof DashboardPartnersCompaniesAddRoute
  '/_dashboard/partners/companies/manage': typeof DashboardPartnersCompaniesManageRoute
  '/(public)/p/$slug/': typeof publicPSlugIndexRoute
  '/_dashboard/_customer/users/': typeof DashboardCustomerUsersIndexRoute
  '/_dashboard/lender/applications/': typeof DashboardLenderApplicationsIndexRoute
  '/_dashboard/partners/companies/': typeof DashboardPartnersCompaniesIndexRoute
  '/_dashboard/_application-flow/applications/$applicationUuid/sign': typeof DashboardApplicationFlowApplicationsApplicationUuidSignRoute
  '/_dashboard/_application-flow/applications/$applicationUuid/submit': typeof DashboardApplicationFlowApplicationsApplicationUuidSubmitRoute
  '/_dashboard/_application-flow/applications/$applicationUuid/upload-documents': typeof DashboardApplicationFlowApplicationsApplicationUuidUploadDocumentsRoute
  '/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid/lender-match': typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidLenderMatchRoute
  '/_dashboard/lender/applications/details/$uuid': typeof DashboardLenderApplicationsDetailsUuidRoute
  '/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid/': typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/embed'
    | '/applications'
    | '/company'
    | '/funding-requests'
    | '/lender'
    | '/partners'
    | '/fundready'
    | '/documents'
    | '/resume'
    | '/embed/signup-complete'
    | '/embed/'
    | '/p/$slug'
    | '/users'
    | '/company-invitation'
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/companies'
    | '/debt-table'
    | '/home'
    | '/perks'
    | '/refer'
    | '/company/address'
    | '/company/articles-of-incorporation'
    | '/company/debt-table'
    | '/company/details'
    | '/company/extra-details'
    | '/company/ownership-details'
    | '/company/plaid'
    | '/lender/home'
    | '/lender/profile'
    | '/lender/users'
    | '/partners/banking'
    | '/partners/guide'
    | '/partners/home'
    | '/partners/referrals'
    | '/partners/users'
    | '/settings/my-account'
    | '/applications/'
    | '/company/'
    | '/funding-requests/'
    | '/lender/'
    | '/partners/'
    | '/applications/$applicationUuid'
    | '/funding-requests/$fundingNeedsUuid'
    | '/p/$slug/login'
    | '/p/$slug/signup'
    | '/funding-requests/create'
    | '/users/activity'
    | '/applications/$applicationUuid/summary'
    | '/lender/applications/list'
    | '/partners/companies/add'
    | '/partners/companies/manage'
    | '/p/$slug/'
    | '/users/'
    | '/lender/applications/'
    | '/partners/companies/'
    | '/applications/$applicationUuid/sign'
    | '/applications/$applicationUuid/submit'
    | '/applications/$applicationUuid/upload-documents'
    | '/funding-requests/$fundingNeedsUuid/lender-match'
    | '/lender/applications/details/$uuid'
    | '/funding-requests/$fundingNeedsUuid/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/fundready'
    | '/documents'
    | '/resume'
    | '/embed/signup-complete'
    | '/embed'
    | '/company-invitation'
    | '/forgot-password'
    | '/invitation'
    | '/login'
    | '/reset-password'
    | '/signup'
    | '/companies'
    | '/debt-table'
    | '/home'
    | '/perks'
    | '/refer'
    | '/company/address'
    | '/company/articles-of-incorporation'
    | '/company/debt-table'
    | '/company/details'
    | '/company/extra-details'
    | '/company/ownership-details'
    | '/company/plaid'
    | '/lender/home'
    | '/lender/profile'
    | '/lender/users'
    | '/partners/banking'
    | '/partners/guide'
    | '/partners/home'
    | '/partners/referrals'
    | '/partners/users'
    | '/settings/my-account'
    | '/applications'
    | '/company'
    | '/funding-requests'
    | '/lender'
    | '/partners'
    | '/applications/$applicationUuid'
    | '/p/$slug/login'
    | '/p/$slug/signup'
    | '/funding-requests/create'
    | '/users/activity'
    | '/applications/$applicationUuid/summary'
    | '/lender/applications/list'
    | '/partners/companies/add'
    | '/partners/companies/manage'
    | '/p/$slug'
    | '/users'
    | '/lender/applications'
    | '/partners/companies'
    | '/applications/$applicationUuid/sign'
    | '/applications/$applicationUuid/submit'
    | '/applications/$applicationUuid/upload-documents'
    | '/funding-requests/$fundingNeedsUuid/lender-match'
    | '/lender/applications/details/$uuid'
    | '/funding-requests/$fundingNeedsUuid'
  id:
    | '__root__'
    | '/_dashboard'
    | '/embed'
    | '/(public)/_account'
    | '/_dashboard/_application-flow'
    | '/_dashboard/_customer'
    | '/_dashboard/applications'
    | '/_dashboard/company'
    | '/_dashboard/funding-requests'
    | '/_dashboard/lender'
    | '/_dashboard/partners'
    | '/(public)/fundready'
    | '/_dashboard/documents'
    | '/_dashboard/resume'
    | '/embed/signup-complete'
    | '/(public)/'
    | '/embed/'
    | '/(public)/p/$slug'
    | '/_dashboard/_customer/users'
    | '/(public)/_account/company-invitation'
    | '/(public)/_account/forgot-password'
    | '/(public)/_account/invitation'
    | '/(public)/_account/login'
    | '/(public)/_account/reset-password'
    | '/(public)/_account/signup'
    | '/_dashboard/_customer/companies'
    | '/_dashboard/_customer/debt-table'
    | '/_dashboard/_customer/home'
    | '/_dashboard/_customer/perks'
    | '/_dashboard/_customer/refer'
    | '/_dashboard/company/address'
    | '/_dashboard/company/articles-of-incorporation'
    | '/_dashboard/company/debt-table'
    | '/_dashboard/company/details'
    | '/_dashboard/company/extra-details'
    | '/_dashboard/company/ownership-details'
    | '/_dashboard/company/plaid'
    | '/_dashboard/lender/home'
    | '/_dashboard/lender/profile'
    | '/_dashboard/lender/users'
    | '/_dashboard/partners/banking'
    | '/_dashboard/partners/guide'
    | '/_dashboard/partners/home'
    | '/_dashboard/partners/referrals'
    | '/_dashboard/partners/users'
    | '/_dashboard/settings/my-account'
    | '/_dashboard/applications/'
    | '/_dashboard/company/'
    | '/_dashboard/funding-requests/'
    | '/_dashboard/lender/'
    | '/_dashboard/partners/'
    | '/_dashboard/_application-flow/applications/$applicationUuid'
    | '/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid'
    | '/(public)/p/$slug/login'
    | '/(public)/p/$slug/signup'
    | '/_dashboard/_application-flow/funding-requests/create'
    | '/_dashboard/_customer/users/activity'
    | '/_dashboard/applications/$applicationUuid/summary'
    | '/_dashboard/lender/applications/list'
    | '/_dashboard/partners/companies/add'
    | '/_dashboard/partners/companies/manage'
    | '/(public)/p/$slug/'
    | '/_dashboard/_customer/users/'
    | '/_dashboard/lender/applications/'
    | '/_dashboard/partners/companies/'
    | '/_dashboard/_application-flow/applications/$applicationUuid/sign'
    | '/_dashboard/_application-flow/applications/$applicationUuid/submit'
    | '/_dashboard/_application-flow/applications/$applicationUuid/upload-documents'
    | '/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid/lender-match'
    | '/_dashboard/lender/applications/details/$uuid'
    | '/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  DashboardRouteRoute: typeof DashboardRouteRouteWithChildren
  EmbedRouteRoute: typeof EmbedRouteRouteWithChildren
  publicAccountRouteRoute: typeof publicAccountRouteRouteWithChildren
  publicFundreadyRoute: typeof publicFundreadyRoute
  publicIndexRoute: typeof publicIndexRoute
  publicPSlugRouteRoute: typeof publicPSlugRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/embed': {
      id: '/embed'
      path: '/embed'
      fullPath: '/embed'
      preLoaderRoute: typeof EmbedRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard': {
      id: '/_dashboard'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/': {
      id: '/embed/'
      path: '/'
      fullPath: '/embed/'
      preLoaderRoute: typeof EmbedIndexRouteImport
      parentRoute: typeof EmbedRouteRoute
    }
    '/(public)/': {
      id: '/(public)/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof publicIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/embed/signup-complete': {
      id: '/embed/signup-complete'
      path: '/signup-complete'
      fullPath: '/embed/signup-complete'
      preLoaderRoute: typeof EmbedSignupCompleteRouteImport
      parentRoute: typeof EmbedRouteRoute
    }
    '/_dashboard/resume': {
      id: '/_dashboard/resume'
      path: '/resume'
      fullPath: '/resume'
      preLoaderRoute: typeof DashboardResumeRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/documents': {
      id: '/_dashboard/documents'
      path: '/documents'
      fullPath: '/documents'
      preLoaderRoute: typeof DashboardDocumentsRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/(public)/fundready': {
      id: '/(public)/fundready'
      path: '/fundready'
      fullPath: '/fundready'
      preLoaderRoute: typeof publicFundreadyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/partners': {
      id: '/_dashboard/partners'
      path: '/partners'
      fullPath: '/partners'
      preLoaderRoute: typeof DashboardPartnersRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/lender': {
      id: '/_dashboard/lender'
      path: '/lender'
      fullPath: '/lender'
      preLoaderRoute: typeof DashboardLenderRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/funding-requests': {
      id: '/_dashboard/funding-requests'
      path: '/funding-requests'
      fullPath: '/funding-requests'
      preLoaderRoute: typeof DashboardFundingRequestsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/company': {
      id: '/_dashboard/company'
      path: '/company'
      fullPath: '/company'
      preLoaderRoute: typeof DashboardCompanyRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/applications': {
      id: '/_dashboard/applications'
      path: '/applications'
      fullPath: '/applications'
      preLoaderRoute: typeof DashboardApplicationsRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/_customer': {
      id: '/_dashboard/_customer'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardCustomerRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/_application-flow': {
      id: '/_dashboard/_application-flow'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof DashboardApplicationFlowRouteRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/(public)/_account': {
      id: '/(public)/_account'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof publicAccountRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/partners/': {
      id: '/_dashboard/partners/'
      path: '/'
      fullPath: '/partners/'
      preLoaderRoute: typeof DashboardPartnersIndexRouteImport
      parentRoute: typeof DashboardPartnersRouteRoute
    }
    '/_dashboard/lender/': {
      id: '/_dashboard/lender/'
      path: '/'
      fullPath: '/lender/'
      preLoaderRoute: typeof DashboardLenderIndexRouteImport
      parentRoute: typeof DashboardLenderRouteRoute
    }
    '/_dashboard/funding-requests/': {
      id: '/_dashboard/funding-requests/'
      path: '/'
      fullPath: '/funding-requests/'
      preLoaderRoute: typeof DashboardFundingRequestsIndexRouteImport
      parentRoute: typeof DashboardFundingRequestsRouteRoute
    }
    '/_dashboard/company/': {
      id: '/_dashboard/company/'
      path: '/'
      fullPath: '/company/'
      preLoaderRoute: typeof DashboardCompanyIndexRouteImport
      parentRoute: typeof DashboardCompanyRouteRoute
    }
    '/_dashboard/applications/': {
      id: '/_dashboard/applications/'
      path: '/'
      fullPath: '/applications/'
      preLoaderRoute: typeof DashboardApplicationsIndexRouteImport
      parentRoute: typeof DashboardApplicationsRouteRoute
    }
    '/_dashboard/settings/my-account': {
      id: '/_dashboard/settings/my-account'
      path: '/settings/my-account'
      fullPath: '/settings/my-account'
      preLoaderRoute: typeof DashboardSettingsMyAccountRouteImport
      parentRoute: typeof DashboardRouteRoute
    }
    '/_dashboard/partners/users': {
      id: '/_dashboard/partners/users'
      path: '/users'
      fullPath: '/partners/users'
      preLoaderRoute: typeof DashboardPartnersUsersRouteImport
      parentRoute: typeof DashboardPartnersRouteRoute
    }
    '/_dashboard/partners/referrals': {
      id: '/_dashboard/partners/referrals'
      path: '/referrals'
      fullPath: '/partners/referrals'
      preLoaderRoute: typeof DashboardPartnersReferralsRouteImport
      parentRoute: typeof DashboardPartnersRouteRoute
    }
    '/_dashboard/partners/home': {
      id: '/_dashboard/partners/home'
      path: '/home'
      fullPath: '/partners/home'
      preLoaderRoute: typeof DashboardPartnersHomeRouteImport
      parentRoute: typeof DashboardPartnersRouteRoute
    }
    '/_dashboard/partners/guide': {
      id: '/_dashboard/partners/guide'
      path: '/guide'
      fullPath: '/partners/guide'
      preLoaderRoute: typeof DashboardPartnersGuideRouteImport
      parentRoute: typeof DashboardPartnersRouteRoute
    }
    '/_dashboard/partners/banking': {
      id: '/_dashboard/partners/banking'
      path: '/banking'
      fullPath: '/partners/banking'
      preLoaderRoute: typeof DashboardPartnersBankingRouteImport
      parentRoute: typeof DashboardPartnersRouteRoute
    }
    '/_dashboard/lender/users': {
      id: '/_dashboard/lender/users'
      path: '/users'
      fullPath: '/lender/users'
      preLoaderRoute: typeof DashboardLenderUsersRouteImport
      parentRoute: typeof DashboardLenderRouteRoute
    }
    '/_dashboard/lender/profile': {
      id: '/_dashboard/lender/profile'
      path: '/profile'
      fullPath: '/lender/profile'
      preLoaderRoute: typeof DashboardLenderProfileRouteImport
      parentRoute: typeof DashboardLenderRouteRoute
    }
    '/_dashboard/lender/home': {
      id: '/_dashboard/lender/home'
      path: '/home'
      fullPath: '/lender/home'
      preLoaderRoute: typeof DashboardLenderHomeRouteImport
      parentRoute: typeof DashboardLenderRouteRoute
    }
    '/_dashboard/company/plaid': {
      id: '/_dashboard/company/plaid'
      path: '/plaid'
      fullPath: '/company/plaid'
      preLoaderRoute: typeof DashboardCompanyPlaidRouteImport
      parentRoute: typeof DashboardCompanyRouteRoute
    }
    '/_dashboard/company/ownership-details': {
      id: '/_dashboard/company/ownership-details'
      path: '/ownership-details'
      fullPath: '/company/ownership-details'
      preLoaderRoute: typeof DashboardCompanyOwnershipDetailsRouteImport
      parentRoute: typeof DashboardCompanyRouteRoute
    }
    '/_dashboard/company/extra-details': {
      id: '/_dashboard/company/extra-details'
      path: '/extra-details'
      fullPath: '/company/extra-details'
      preLoaderRoute: typeof DashboardCompanyExtraDetailsRouteImport
      parentRoute: typeof DashboardCompanyRouteRoute
    }
    '/_dashboard/company/details': {
      id: '/_dashboard/company/details'
      path: '/details'
      fullPath: '/company/details'
      preLoaderRoute: typeof DashboardCompanyDetailsRouteImport
      parentRoute: typeof DashboardCompanyRouteRoute
    }
    '/_dashboard/company/debt-table': {
      id: '/_dashboard/company/debt-table'
      path: '/debt-table'
      fullPath: '/company/debt-table'
      preLoaderRoute: typeof DashboardCompanyDebtTableRouteImport
      parentRoute: typeof DashboardCompanyRouteRoute
    }
    '/_dashboard/company/articles-of-incorporation': {
      id: '/_dashboard/company/articles-of-incorporation'
      path: '/articles-of-incorporation'
      fullPath: '/company/articles-of-incorporation'
      preLoaderRoute: typeof DashboardCompanyArticlesOfIncorporationRouteImport
      parentRoute: typeof DashboardCompanyRouteRoute
    }
    '/_dashboard/company/address': {
      id: '/_dashboard/company/address'
      path: '/address'
      fullPath: '/company/address'
      preLoaderRoute: typeof DashboardCompanyAddressRouteImport
      parentRoute: typeof DashboardCompanyRouteRoute
    }
    '/_dashboard/_customer/refer': {
      id: '/_dashboard/_customer/refer'
      path: '/refer'
      fullPath: '/refer'
      preLoaderRoute: typeof DashboardCustomerReferRouteImport
      parentRoute: typeof DashboardCustomerRouteRoute
    }
    '/_dashboard/_customer/perks': {
      id: '/_dashboard/_customer/perks'
      path: '/perks'
      fullPath: '/perks'
      preLoaderRoute: typeof DashboardCustomerPerksRouteImport
      parentRoute: typeof DashboardCustomerRouteRoute
    }
    '/_dashboard/_customer/home': {
      id: '/_dashboard/_customer/home'
      path: '/home'
      fullPath: '/home'
      preLoaderRoute: typeof DashboardCustomerHomeRouteImport
      parentRoute: typeof DashboardCustomerRouteRoute
    }
    '/_dashboard/_customer/debt-table': {
      id: '/_dashboard/_customer/debt-table'
      path: '/debt-table'
      fullPath: '/debt-table'
      preLoaderRoute: typeof DashboardCustomerDebtTableRouteImport
      parentRoute: typeof DashboardCustomerRouteRoute
    }
    '/_dashboard/_customer/companies': {
      id: '/_dashboard/_customer/companies'
      path: '/companies'
      fullPath: '/companies'
      preLoaderRoute: typeof DashboardCustomerCompaniesRouteImport
      parentRoute: typeof DashboardCustomerRouteRoute
    }
    '/(public)/_account/signup': {
      id: '/(public)/_account/signup'
      path: '/signup'
      fullPath: '/signup'
      preLoaderRoute: typeof publicAccountSignupRouteImport
      parentRoute: typeof publicAccountRouteRoute
    }
    '/(public)/_account/reset-password': {
      id: '/(public)/_account/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof publicAccountResetPasswordRouteImport
      parentRoute: typeof publicAccountRouteRoute
    }
    '/(public)/_account/login': {
      id: '/(public)/_account/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof publicAccountLoginRouteImport
      parentRoute: typeof publicAccountRouteRoute
    }
    '/(public)/_account/invitation': {
      id: '/(public)/_account/invitation'
      path: '/invitation'
      fullPath: '/invitation'
      preLoaderRoute: typeof publicAccountInvitationRouteImport
      parentRoute: typeof publicAccountRouteRoute
    }
    '/(public)/_account/forgot-password': {
      id: '/(public)/_account/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof publicAccountForgotPasswordRouteImport
      parentRoute: typeof publicAccountRouteRoute
    }
    '/(public)/_account/company-invitation': {
      id: '/(public)/_account/company-invitation'
      path: '/company-invitation'
      fullPath: '/company-invitation'
      preLoaderRoute: typeof publicAccountCompanyInvitationRouteImport
      parentRoute: typeof publicAccountRouteRoute
    }
    '/_dashboard/_customer/users': {
      id: '/_dashboard/_customer/users'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof DashboardCustomerUsersRouteRouteImport
      parentRoute: typeof DashboardCustomerRouteRoute
    }
    '/(public)/p/$slug': {
      id: '/(public)/p/$slug'
      path: '/p/$slug'
      fullPath: '/p/$slug'
      preLoaderRoute: typeof publicPSlugRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_dashboard/partners/companies/': {
      id: '/_dashboard/partners/companies/'
      path: '/companies'
      fullPath: '/partners/companies/'
      preLoaderRoute: typeof DashboardPartnersCompaniesIndexRouteImport
      parentRoute: typeof DashboardPartnersRouteRoute
    }
    '/_dashboard/lender/applications/': {
      id: '/_dashboard/lender/applications/'
      path: '/applications'
      fullPath: '/lender/applications/'
      preLoaderRoute: typeof DashboardLenderApplicationsIndexRouteImport
      parentRoute: typeof DashboardLenderRouteRoute
    }
    '/_dashboard/_customer/users/': {
      id: '/_dashboard/_customer/users/'
      path: '/'
      fullPath: '/users/'
      preLoaderRoute: typeof DashboardCustomerUsersIndexRouteImport
      parentRoute: typeof DashboardCustomerUsersRouteRoute
    }
    '/(public)/p/$slug/': {
      id: '/(public)/p/$slug/'
      path: '/'
      fullPath: '/p/$slug/'
      preLoaderRoute: typeof publicPSlugIndexRouteImport
      parentRoute: typeof publicPSlugRouteRoute
    }
    '/_dashboard/partners/companies/manage': {
      id: '/_dashboard/partners/companies/manage'
      path: '/companies/manage'
      fullPath: '/partners/companies/manage'
      preLoaderRoute: typeof DashboardPartnersCompaniesManageRouteImport
      parentRoute: typeof DashboardPartnersRouteRoute
    }
    '/_dashboard/partners/companies/add': {
      id: '/_dashboard/partners/companies/add'
      path: '/companies/add'
      fullPath: '/partners/companies/add'
      preLoaderRoute: typeof DashboardPartnersCompaniesAddRouteImport
      parentRoute: typeof DashboardPartnersRouteRoute
    }
    '/_dashboard/lender/applications/list': {
      id: '/_dashboard/lender/applications/list'
      path: '/applications/list'
      fullPath: '/lender/applications/list'
      preLoaderRoute: typeof DashboardLenderApplicationsListRouteImport
      parentRoute: typeof DashboardLenderRouteRoute
    }
    '/_dashboard/applications/$applicationUuid/summary': {
      id: '/_dashboard/applications/$applicationUuid/summary'
      path: '/$applicationUuid/summary'
      fullPath: '/applications/$applicationUuid/summary'
      preLoaderRoute: typeof DashboardApplicationsApplicationUuidSummaryRouteImport
      parentRoute: typeof DashboardApplicationsRouteRoute
    }
    '/_dashboard/_customer/users/activity': {
      id: '/_dashboard/_customer/users/activity'
      path: '/activity'
      fullPath: '/users/activity'
      preLoaderRoute: typeof DashboardCustomerUsersActivityRouteImport
      parentRoute: typeof DashboardCustomerUsersRouteRoute
    }
    '/_dashboard/_application-flow/funding-requests/create': {
      id: '/_dashboard/_application-flow/funding-requests/create'
      path: '/funding-requests/create'
      fullPath: '/funding-requests/create'
      preLoaderRoute: typeof DashboardApplicationFlowFundingRequestsCreateRouteImport
      parentRoute: typeof DashboardApplicationFlowRouteRoute
    }
    '/(public)/p/$slug/signup': {
      id: '/(public)/p/$slug/signup'
      path: '/signup'
      fullPath: '/p/$slug/signup'
      preLoaderRoute: typeof publicPSlugSignupRouteImport
      parentRoute: typeof publicPSlugRouteRoute
    }
    '/(public)/p/$slug/login': {
      id: '/(public)/p/$slug/login'
      path: '/login'
      fullPath: '/p/$slug/login'
      preLoaderRoute: typeof publicPSlugLoginRouteImport
      parentRoute: typeof publicPSlugRouteRoute
    }
    '/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid': {
      id: '/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid'
      path: '/funding-requests/$fundingNeedsUuid'
      fullPath: '/funding-requests/$fundingNeedsUuid'
      preLoaderRoute: typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRouteImport
      parentRoute: typeof DashboardApplicationFlowRouteRoute
    }
    '/_dashboard/_application-flow/applications/$applicationUuid': {
      id: '/_dashboard/_application-flow/applications/$applicationUuid'
      path: '/applications/$applicationUuid'
      fullPath: '/applications/$applicationUuid'
      preLoaderRoute: typeof DashboardApplicationFlowApplicationsApplicationUuidRouteRouteImport
      parentRoute: typeof DashboardApplicationFlowRouteRoute
    }
    '/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid/': {
      id: '/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid/'
      path: '/'
      fullPath: '/funding-requests/$fundingNeedsUuid/'
      preLoaderRoute: typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidIndexRouteImport
      parentRoute: typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRoute
    }
    '/_dashboard/lender/applications/details/$uuid': {
      id: '/_dashboard/lender/applications/details/$uuid'
      path: '/applications/details/$uuid'
      fullPath: '/lender/applications/details/$uuid'
      preLoaderRoute: typeof DashboardLenderApplicationsDetailsUuidRouteImport
      parentRoute: typeof DashboardLenderRouteRoute
    }
    '/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid/lender-match': {
      id: '/_dashboard/_application-flow/funding-requests/$fundingNeedsUuid/lender-match'
      path: '/lender-match'
      fullPath: '/funding-requests/$fundingNeedsUuid/lender-match'
      preLoaderRoute: typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidLenderMatchRouteImport
      parentRoute: typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRoute
    }
    '/_dashboard/_application-flow/applications/$applicationUuid/upload-documents': {
      id: '/_dashboard/_application-flow/applications/$applicationUuid/upload-documents'
      path: '/upload-documents'
      fullPath: '/applications/$applicationUuid/upload-documents'
      preLoaderRoute: typeof DashboardApplicationFlowApplicationsApplicationUuidUploadDocumentsRouteImport
      parentRoute: typeof DashboardApplicationFlowApplicationsApplicationUuidRouteRoute
    }
    '/_dashboard/_application-flow/applications/$applicationUuid/submit': {
      id: '/_dashboard/_application-flow/applications/$applicationUuid/submit'
      path: '/submit'
      fullPath: '/applications/$applicationUuid/submit'
      preLoaderRoute: typeof DashboardApplicationFlowApplicationsApplicationUuidSubmitRouteImport
      parentRoute: typeof DashboardApplicationFlowApplicationsApplicationUuidRouteRoute
    }
    '/_dashboard/_application-flow/applications/$applicationUuid/sign': {
      id: '/_dashboard/_application-flow/applications/$applicationUuid/sign'
      path: '/sign'
      fullPath: '/applications/$applicationUuid/sign'
      preLoaderRoute: typeof DashboardApplicationFlowApplicationsApplicationUuidSignRouteImport
      parentRoute: typeof DashboardApplicationFlowApplicationsApplicationUuidRouteRoute
    }
  }
}

interface DashboardApplicationFlowApplicationsApplicationUuidRouteRouteChildren {
  DashboardApplicationFlowApplicationsApplicationUuidSignRoute: typeof DashboardApplicationFlowApplicationsApplicationUuidSignRoute
  DashboardApplicationFlowApplicationsApplicationUuidSubmitRoute: typeof DashboardApplicationFlowApplicationsApplicationUuidSubmitRoute
  DashboardApplicationFlowApplicationsApplicationUuidUploadDocumentsRoute: typeof DashboardApplicationFlowApplicationsApplicationUuidUploadDocumentsRoute
}

const DashboardApplicationFlowApplicationsApplicationUuidRouteRouteChildren: DashboardApplicationFlowApplicationsApplicationUuidRouteRouteChildren =
  {
    DashboardApplicationFlowApplicationsApplicationUuidSignRoute:
      DashboardApplicationFlowApplicationsApplicationUuidSignRoute,
    DashboardApplicationFlowApplicationsApplicationUuidSubmitRoute:
      DashboardApplicationFlowApplicationsApplicationUuidSubmitRoute,
    DashboardApplicationFlowApplicationsApplicationUuidUploadDocumentsRoute:
      DashboardApplicationFlowApplicationsApplicationUuidUploadDocumentsRoute,
  }

const DashboardApplicationFlowApplicationsApplicationUuidRouteRouteWithChildren =
  DashboardApplicationFlowApplicationsApplicationUuidRouteRoute._addFileChildren(
    DashboardApplicationFlowApplicationsApplicationUuidRouteRouteChildren,
  )

interface DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRouteChildren {
  DashboardApplicationFlowFundingRequestsFundingNeedsUuidLenderMatchRoute: typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidLenderMatchRoute
  DashboardApplicationFlowFundingRequestsFundingNeedsUuidIndexRoute: typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidIndexRoute
}

const DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRouteChildren: DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRouteChildren =
  {
    DashboardApplicationFlowFundingRequestsFundingNeedsUuidLenderMatchRoute:
      DashboardApplicationFlowFundingRequestsFundingNeedsUuidLenderMatchRoute,
    DashboardApplicationFlowFundingRequestsFundingNeedsUuidIndexRoute:
      DashboardApplicationFlowFundingRequestsFundingNeedsUuidIndexRoute,
  }

const DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRouteWithChildren =
  DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRoute._addFileChildren(
    DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRouteChildren,
  )

interface DashboardApplicationFlowRouteRouteChildren {
  DashboardApplicationFlowApplicationsApplicationUuidRouteRoute: typeof DashboardApplicationFlowApplicationsApplicationUuidRouteRouteWithChildren
  DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRoute: typeof DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRouteWithChildren
  DashboardApplicationFlowFundingRequestsCreateRoute: typeof DashboardApplicationFlowFundingRequestsCreateRoute
}

const DashboardApplicationFlowRouteRouteChildren: DashboardApplicationFlowRouteRouteChildren =
  {
    DashboardApplicationFlowApplicationsApplicationUuidRouteRoute:
      DashboardApplicationFlowApplicationsApplicationUuidRouteRouteWithChildren,
    DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRoute:
      DashboardApplicationFlowFundingRequestsFundingNeedsUuidRouteRouteWithChildren,
    DashboardApplicationFlowFundingRequestsCreateRoute:
      DashboardApplicationFlowFundingRequestsCreateRoute,
  }

const DashboardApplicationFlowRouteRouteWithChildren =
  DashboardApplicationFlowRouteRoute._addFileChildren(
    DashboardApplicationFlowRouteRouteChildren,
  )

interface DashboardCustomerUsersRouteRouteChildren {
  DashboardCustomerUsersActivityRoute: typeof DashboardCustomerUsersActivityRoute
  DashboardCustomerUsersIndexRoute: typeof DashboardCustomerUsersIndexRoute
}

const DashboardCustomerUsersRouteRouteChildren: DashboardCustomerUsersRouteRouteChildren =
  {
    DashboardCustomerUsersActivityRoute: DashboardCustomerUsersActivityRoute,
    DashboardCustomerUsersIndexRoute: DashboardCustomerUsersIndexRoute,
  }

const DashboardCustomerUsersRouteRouteWithChildren =
  DashboardCustomerUsersRouteRoute._addFileChildren(
    DashboardCustomerUsersRouteRouteChildren,
  )

interface DashboardCustomerRouteRouteChildren {
  DashboardCustomerUsersRouteRoute: typeof DashboardCustomerUsersRouteRouteWithChildren
  DashboardCustomerCompaniesRoute: typeof DashboardCustomerCompaniesRoute
  DashboardCustomerDebtTableRoute: typeof DashboardCustomerDebtTableRoute
  DashboardCustomerHomeRoute: typeof DashboardCustomerHomeRoute
  DashboardCustomerPerksRoute: typeof DashboardCustomerPerksRoute
  DashboardCustomerReferRoute: typeof DashboardCustomerReferRoute
}

const DashboardCustomerRouteRouteChildren: DashboardCustomerRouteRouteChildren =
  {
    DashboardCustomerUsersRouteRoute:
      DashboardCustomerUsersRouteRouteWithChildren,
    DashboardCustomerCompaniesRoute: DashboardCustomerCompaniesRoute,
    DashboardCustomerDebtTableRoute: DashboardCustomerDebtTableRoute,
    DashboardCustomerHomeRoute: DashboardCustomerHomeRoute,
    DashboardCustomerPerksRoute: DashboardCustomerPerksRoute,
    DashboardCustomerReferRoute: DashboardCustomerReferRoute,
  }

const DashboardCustomerRouteRouteWithChildren =
  DashboardCustomerRouteRoute._addFileChildren(
    DashboardCustomerRouteRouteChildren,
  )

interface DashboardApplicationsRouteRouteChildren {
  DashboardApplicationsIndexRoute: typeof DashboardApplicationsIndexRoute
  DashboardApplicationsApplicationUuidSummaryRoute: typeof DashboardApplicationsApplicationUuidSummaryRoute
}

const DashboardApplicationsRouteRouteChildren: DashboardApplicationsRouteRouteChildren =
  {
    DashboardApplicationsIndexRoute: DashboardApplicationsIndexRoute,
    DashboardApplicationsApplicationUuidSummaryRoute:
      DashboardApplicationsApplicationUuidSummaryRoute,
  }

const DashboardApplicationsRouteRouteWithChildren =
  DashboardApplicationsRouteRoute._addFileChildren(
    DashboardApplicationsRouteRouteChildren,
  )

interface DashboardCompanyRouteRouteChildren {
  DashboardCompanyAddressRoute: typeof DashboardCompanyAddressRoute
  DashboardCompanyArticlesOfIncorporationRoute: typeof DashboardCompanyArticlesOfIncorporationRoute
  DashboardCompanyDebtTableRoute: typeof DashboardCompanyDebtTableRoute
  DashboardCompanyDetailsRoute: typeof DashboardCompanyDetailsRoute
  DashboardCompanyExtraDetailsRoute: typeof DashboardCompanyExtraDetailsRoute
  DashboardCompanyOwnershipDetailsRoute: typeof DashboardCompanyOwnershipDetailsRoute
  DashboardCompanyPlaidRoute: typeof DashboardCompanyPlaidRoute
  DashboardCompanyIndexRoute: typeof DashboardCompanyIndexRoute
}

const DashboardCompanyRouteRouteChildren: DashboardCompanyRouteRouteChildren = {
  DashboardCompanyAddressRoute: DashboardCompanyAddressRoute,
  DashboardCompanyArticlesOfIncorporationRoute:
    DashboardCompanyArticlesOfIncorporationRoute,
  DashboardCompanyDebtTableRoute: DashboardCompanyDebtTableRoute,
  DashboardCompanyDetailsRoute: DashboardCompanyDetailsRoute,
  DashboardCompanyExtraDetailsRoute: DashboardCompanyExtraDetailsRoute,
  DashboardCompanyOwnershipDetailsRoute: DashboardCompanyOwnershipDetailsRoute,
  DashboardCompanyPlaidRoute: DashboardCompanyPlaidRoute,
  DashboardCompanyIndexRoute: DashboardCompanyIndexRoute,
}

const DashboardCompanyRouteRouteWithChildren =
  DashboardCompanyRouteRoute._addFileChildren(
    DashboardCompanyRouteRouteChildren,
  )

interface DashboardFundingRequestsRouteRouteChildren {
  DashboardFundingRequestsIndexRoute: typeof DashboardFundingRequestsIndexRoute
}

const DashboardFundingRequestsRouteRouteChildren: DashboardFundingRequestsRouteRouteChildren =
  {
    DashboardFundingRequestsIndexRoute: DashboardFundingRequestsIndexRoute,
  }

const DashboardFundingRequestsRouteRouteWithChildren =
  DashboardFundingRequestsRouteRoute._addFileChildren(
    DashboardFundingRequestsRouteRouteChildren,
  )

interface DashboardLenderRouteRouteChildren {
  DashboardLenderHomeRoute: typeof DashboardLenderHomeRoute
  DashboardLenderProfileRoute: typeof DashboardLenderProfileRoute
  DashboardLenderUsersRoute: typeof DashboardLenderUsersRoute
  DashboardLenderIndexRoute: typeof DashboardLenderIndexRoute
  DashboardLenderApplicationsListRoute: typeof DashboardLenderApplicationsListRoute
  DashboardLenderApplicationsIndexRoute: typeof DashboardLenderApplicationsIndexRoute
  DashboardLenderApplicationsDetailsUuidRoute: typeof DashboardLenderApplicationsDetailsUuidRoute
}

const DashboardLenderRouteRouteChildren: DashboardLenderRouteRouteChildren = {
  DashboardLenderHomeRoute: DashboardLenderHomeRoute,
  DashboardLenderProfileRoute: DashboardLenderProfileRoute,
  DashboardLenderUsersRoute: DashboardLenderUsersRoute,
  DashboardLenderIndexRoute: DashboardLenderIndexRoute,
  DashboardLenderApplicationsListRoute: DashboardLenderApplicationsListRoute,
  DashboardLenderApplicationsIndexRoute: DashboardLenderApplicationsIndexRoute,
  DashboardLenderApplicationsDetailsUuidRoute:
    DashboardLenderApplicationsDetailsUuidRoute,
}

const DashboardLenderRouteRouteWithChildren =
  DashboardLenderRouteRoute._addFileChildren(DashboardLenderRouteRouteChildren)

interface DashboardPartnersRouteRouteChildren {
  DashboardPartnersBankingRoute: typeof DashboardPartnersBankingRoute
  DashboardPartnersGuideRoute: typeof DashboardPartnersGuideRoute
  DashboardPartnersHomeRoute: typeof DashboardPartnersHomeRoute
  DashboardPartnersReferralsRoute: typeof DashboardPartnersReferralsRoute
  DashboardPartnersUsersRoute: typeof DashboardPartnersUsersRoute
  DashboardPartnersIndexRoute: typeof DashboardPartnersIndexRoute
  DashboardPartnersCompaniesAddRoute: typeof DashboardPartnersCompaniesAddRoute
  DashboardPartnersCompaniesManageRoute: typeof DashboardPartnersCompaniesManageRoute
  DashboardPartnersCompaniesIndexRoute: typeof DashboardPartnersCompaniesIndexRoute
}

const DashboardPartnersRouteRouteChildren: DashboardPartnersRouteRouteChildren =
  {
    DashboardPartnersBankingRoute: DashboardPartnersBankingRoute,
    DashboardPartnersGuideRoute: DashboardPartnersGuideRoute,
    DashboardPartnersHomeRoute: DashboardPartnersHomeRoute,
    DashboardPartnersReferralsRoute: DashboardPartnersReferralsRoute,
    DashboardPartnersUsersRoute: DashboardPartnersUsersRoute,
    DashboardPartnersIndexRoute: DashboardPartnersIndexRoute,
    DashboardPartnersCompaniesAddRoute: DashboardPartnersCompaniesAddRoute,
    DashboardPartnersCompaniesManageRoute:
      DashboardPartnersCompaniesManageRoute,
    DashboardPartnersCompaniesIndexRoute: DashboardPartnersCompaniesIndexRoute,
  }

const DashboardPartnersRouteRouteWithChildren =
  DashboardPartnersRouteRoute._addFileChildren(
    DashboardPartnersRouteRouteChildren,
  )

interface DashboardRouteRouteChildren {
  DashboardApplicationFlowRouteRoute: typeof DashboardApplicationFlowRouteRouteWithChildren
  DashboardCustomerRouteRoute: typeof DashboardCustomerRouteRouteWithChildren
  DashboardApplicationsRouteRoute: typeof DashboardApplicationsRouteRouteWithChildren
  DashboardCompanyRouteRoute: typeof DashboardCompanyRouteRouteWithChildren
  DashboardFundingRequestsRouteRoute: typeof DashboardFundingRequestsRouteRouteWithChildren
  DashboardLenderRouteRoute: typeof DashboardLenderRouteRouteWithChildren
  DashboardPartnersRouteRoute: typeof DashboardPartnersRouteRouteWithChildren
  DashboardDocumentsRoute: typeof DashboardDocumentsRoute
  DashboardResumeRoute: typeof DashboardResumeRoute
  DashboardSettingsMyAccountRoute: typeof DashboardSettingsMyAccountRoute
}

const DashboardRouteRouteChildren: DashboardRouteRouteChildren = {
  DashboardApplicationFlowRouteRoute:
    DashboardApplicationFlowRouteRouteWithChildren,
  DashboardCustomerRouteRoute: DashboardCustomerRouteRouteWithChildren,
  DashboardApplicationsRouteRoute: DashboardApplicationsRouteRouteWithChildren,
  DashboardCompanyRouteRoute: DashboardCompanyRouteRouteWithChildren,
  DashboardFundingRequestsRouteRoute:
    DashboardFundingRequestsRouteRouteWithChildren,
  DashboardLenderRouteRoute: DashboardLenderRouteRouteWithChildren,
  DashboardPartnersRouteRoute: DashboardPartnersRouteRouteWithChildren,
  DashboardDocumentsRoute: DashboardDocumentsRoute,
  DashboardResumeRoute: DashboardResumeRoute,
  DashboardSettingsMyAccountRoute: DashboardSettingsMyAccountRoute,
}

const DashboardRouteRouteWithChildren = DashboardRouteRoute._addFileChildren(
  DashboardRouteRouteChildren,
)

interface EmbedRouteRouteChildren {
  EmbedSignupCompleteRoute: typeof EmbedSignupCompleteRoute
  EmbedIndexRoute: typeof EmbedIndexRoute
}

const EmbedRouteRouteChildren: EmbedRouteRouteChildren = {
  EmbedSignupCompleteRoute: EmbedSignupCompleteRoute,
  EmbedIndexRoute: EmbedIndexRoute,
}

const EmbedRouteRouteWithChildren = EmbedRouteRoute._addFileChildren(
  EmbedRouteRouteChildren,
)

interface publicAccountRouteRouteChildren {
  publicAccountCompanyInvitationRoute: typeof publicAccountCompanyInvitationRoute
  publicAccountForgotPasswordRoute: typeof publicAccountForgotPasswordRoute
  publicAccountInvitationRoute: typeof publicAccountInvitationRoute
  publicAccountLoginRoute: typeof publicAccountLoginRoute
  publicAccountResetPasswordRoute: typeof publicAccountResetPasswordRoute
  publicAccountSignupRoute: typeof publicAccountSignupRoute
}

const publicAccountRouteRouteChildren: publicAccountRouteRouteChildren = {
  publicAccountCompanyInvitationRoute: publicAccountCompanyInvitationRoute,
  publicAccountForgotPasswordRoute: publicAccountForgotPasswordRoute,
  publicAccountInvitationRoute: publicAccountInvitationRoute,
  publicAccountLoginRoute: publicAccountLoginRoute,
  publicAccountResetPasswordRoute: publicAccountResetPasswordRoute,
  publicAccountSignupRoute: publicAccountSignupRoute,
}

const publicAccountRouteRouteWithChildren =
  publicAccountRouteRoute._addFileChildren(publicAccountRouteRouteChildren)

interface publicPSlugRouteRouteChildren {
  publicPSlugLoginRoute: typeof publicPSlugLoginRoute
  publicPSlugSignupRoute: typeof publicPSlugSignupRoute
  publicPSlugIndexRoute: typeof publicPSlugIndexRoute
}

const publicPSlugRouteRouteChildren: publicPSlugRouteRouteChildren = {
  publicPSlugLoginRoute: publicPSlugLoginRoute,
  publicPSlugSignupRoute: publicPSlugSignupRoute,
  publicPSlugIndexRoute: publicPSlugIndexRoute,
}

const publicPSlugRouteRouteWithChildren =
  publicPSlugRouteRoute._addFileChildren(publicPSlugRouteRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  DashboardRouteRoute: DashboardRouteRouteWithChildren,
  EmbedRouteRoute: EmbedRouteRouteWithChildren,
  publicAccountRouteRoute: publicAccountRouteRouteWithChildren,
  publicFundreadyRoute: publicFundreadyRoute,
  publicIndexRoute: publicIndexRoute,
  publicPSlugRouteRoute: publicPSlugRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
